<template>
	<div class="table-responsive">
  		<table class="table" data-sort="table">
    		<thead>
				<slot name="header"></slot>
    		</thead>
    		<tbody>
				<slot name="body"></slot>
			</tbody>
  		</table>
	</div>
</template>

<script>

	export default {
		name: 'TableView',
		props: ['loading'],
	}
</script>


// WEBPACK FOOTER //
// src/components/TableView.vue